import { createStore } from 'vuex'
import Api from '@/libs/api'

const handleErrors = (fnName, error) => {
    console.log(`${fnName} ERR`, error)
    if (error && error.response && error.response.status == 400) {
        return error.response.data.debug_detail
    }
    return false
}

export default createStore({
    state: {
        success: false,
        routeParams: {},
        config: {
            action:    'recover',
            embed:     false,
            dark:      false,
            lang:      'en',
            agent:     'web',
            endbutton: false,
            token:     '',
            uidb64:    ''
        }
    },
    getters: {
        getAction: function (state) {
            return state.config.action
        },
        isEmbedded: function (state) {
            return state.config.embed === true
        },
        isDarkThemed: function (state) {
            return state.config.dark === true
        },
        showEndButton: function (state) {
            return state.config.endbutton === true
        },
        getLang: function (state) {
            return state.config.lang
        },
        getAgent: function (state) {
            return state.config.agent
        },
        getToken: function (state) {
            return state.config.token
        },
        getUIDB64: function (state) {
            return state.config.uidb64
        },
        getRouteParams: function (state) {
            return state.routeParams
        }
    },
    mutations: {
        resetAction: (state) => {
            state.success = false
            state.config = {
                ...state.config,
                action: 'recover',
                token:  '',
                uidb64: ''
            }
        },
        setSuccess: (state, payload) => {
            state.success = payload === true
        },
        setConfig: (state, payload) => {
            state.config = { ...payload }
        },
        updateLocale: (state, payload) => {
            state.config.lang = payload
        },
        setRouteParams: function (state, payload) {
            state.routeParams = payload
        },
    },
    actions: {
        resetAction: function ({ commit } ) {
            commit('resetAction')
        },
        setConfig: function ({ commit }, config ) {
            let newConfig = {
                embed:      false,
                dark:       false,
                lang:       'en',
                agent:      'web',
                endbutton:  false,
                token:      '',
                uidb64:     ''
            }
            if (config && typeof config == 'string') {
                if (window.location.hash.match('^#/recover')) {
                    newConfig['action'] = 'recover'
                }
                if (window.location.hash.match('^#/change')) {
                    newConfig['action'] = 'change'
                }
                newConfig['embed']      = config.indexOf('embed=true') >= 0 ? true : false
                newConfig['dark']       = config.indexOf('dark=true') >= 0 ? true : false
                newConfig['endbutton']  = config.indexOf('endbutton=true') >= 0 ? true : false
                const matchLang         = config.match(/lang=(de|en|es|fr|it)/)
                newConfig['lang']       = matchLang ? matchLang[1] : 'en'
                const matchAgent        = config.match(/agent=(web|ios|android|mmpro)/)
                newConfig['agent']      = matchAgent ? matchAgent[1] : 'web'
                const matchToken        = config.match(/token=([a-zA-Z0-9-_.]+)/)
                newConfig['token']      = matchToken ? matchToken[1] : ''
                const matchUIDB64       = config.match(/uidb64=([a-zA-Z0-9+\/]+)/)
                newConfig['uidb64']     = matchUIDB64 ? matchUIDB64[1] : ''
            }
            commit ('setConfig', newConfig)
        },
        updateLocale: function ({ commit }, lang ) {
            commit('updateLocale', lang)
        },
        setRouteParams: function ({ commit }, params) {
            commit('setRouteParams', params)
        },
        resetRouteParams: function ({ commit }) {
            commit('setRouteParams', {})
        },
        verifyToken: async function ({ state }) {
            try {
                if (state.config.token) {
                    await Api.POST('api-token-verify/v5', {
                        "token": state.config.token
                    })
                    return true
                }
            } catch (error) {
                console.log('verifyToken ERR', error)
            }
            return false
        },
        submitPassChange: async function ({ state, commit }, payload) {
            try {
                await new Promise (resolve => setTimeout(resolve, 1000))
                await Api.POST('password_change/v1', payload, {
                    "Authorization" : `Bearer ${state.config.token}`
                })
                commit('setSuccess', true)
                return true
            } catch (error) {
                commit('setSuccess', false)
                return handleErrors('submitPassRecover', error)
            }
        },
        submitPassRecover: async function ({ commit }, payload) {
            try {
                await new Promise (resolve => setTimeout(resolve, 1000))
                await Api.POST('password_reset/v1', payload)
                commit('setSuccess', true)
                return true
            } catch (error) {
                commit('setSuccess', false)
                return handleErrors('submitPassRecover', error)
            }
        },
        submitNewPass: async function ({ commit }, payload) {
            try {
                await new Promise (resolve => setTimeout(resolve, 1000))
                await Api.POST('password_reset/v1/confirm', payload)
                commit('setSuccess', true)
                return true
            } catch (error) {
                commit('setSuccess', false)
                return handleErrors('submitNewPass', error)
            }
        }
    }
})
